// extracted by mini-css-extract-plugin
export default {"days":"_2itXT","day":"_5_wIe","empty":"_1a4ok"};